if (!customElements.get('fk-product-collection')) {
  customElements.define('fk-product-collection', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('ul');
      if (!this.list || this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.list.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        this.list.scrollBy({ left: Number(button.dataset.direction) * this.list.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.list);
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadRemaining(signal);
      }, { rootMargin: '200px' });
      this.observer.observe(this);
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      this.observer?.disconnect();
    }

    update() {
      this.hidden = this.list.children.length <= 1 && !this.dataset.next;
      const max = this.list.scrollWidth - this.list.clientWidth;
      this.querySelector('.fk-pcollection__footer').hidden = max < 2;
      this.querySelector('[data-direction="-1"]').disabled = this.list.scrollLeft < 2;
      this.querySelector('[data-direction="1"]').disabled = this.list.scrollLeft >= max - 2;
    }

    async loadRemaining(signal) {
      const seen = new Set([...this.list.children].map(item => item.dataset.collectionItem));
      const pages = new Set();
      try {
        while (this.dataset.next && !signal.aborted) {
          const url = new URL(this.dataset.next, location.origin);
          if (url.origin !== location.origin || pages.has(url.href)) break;
          pages.add(url.href);
          url.searchParams.set('section_id', 'fk-product-collection-page');
          const response = await fetch(url, { signal });
          if (!response.ok) break;
          const fragment = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-collection-page]');
          if (!fragment) break;
          fragment.querySelectorAll('[data-collection-item]').forEach(item => {
            if (seen.has(item.dataset.collectionItem)) return;
            if (this.dataset.filterType && item.dataset.productType !== this.dataset.filterType) return;
            if (this.dataset.familyKey && item.dataset.familyKey !== this.dataset.familyKey) return;
            seen.add(item.dataset.collectionItem);
            this.list.append(item);
          });
          this.dataset.next = fragment.dataset.next || '';
          this.update();
        }
      } catch { /* The collection link remains available if pagination cannot load. */ }
      finally { this.hidden = this.list.children.length <= 1; }
    }
  });
}
